import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
const Warning = ({ visible, setVisible, label, type }) => {
  const setFooter = () => {
    return (
      <Button
        label="Ok"
        onClick={() => {
          setVisible(false)
        }}
      />
    )
  }
  return (
    <Dialog
      visible={visible}
      onHide={() => setVisible(false)}
      style={{ width: "600px" }}
      modal
      footer={setFooter()}
    >
      <label>
        <b>{type}:</b> <i>{label}</i>
      </label>
    </Dialog>
  )
}
export default Warning
